<div class="benefits-menu" *ngIf="categories$ | async as content">
    <div class="select">
        <mat-select [(value)]="currentIndex" (selectionChange)="onChange($event.value)">
            <mat-option *ngFor="let item of content trackBy: trackByFn; let index = index;" [value]="index">
                {{item.name}}
            </mat-option>
        </mat-select>
    </div>

    <div class="tabs">
        <mat-tab-group class="tabs_group" [disableRipple]="true" [selectedIndex]="currentIndex" (selectedTabChange)="onChange($event.index)" dynamicHeight>
            <mat-tab *ngFor="let item of content trackBy: trackByFn;">
                <ng-template mat-tab-label>
                    <div class="tabs__header tabs__header--{{item.id}}">{{item.name}}</div>
                </ng-template>

                <div class="tabs__content">
                    <ul class="tabs__content-list">
                        <li *ngFor="let page of item.pageCategories  | orderBy:['categoryId', 'displayOrder']" class="tabs__content-list-item">

                            <span class="tabs__content-list-icon"><img *ngIf="page.meta && page.meta.icon" class="tabs__content-list-icon-image" [attr.src]="page.meta.icon" alt="" /></span>
                            <span class="tabs__content-list-content">
                                <h3 class="tabs__content-list-header" *ngIf="page.name"><a [attr.href]="page.url" class="tabs__content-list-link">{{page.name}}</a></h3>
                                <span class="tabs__content-list-category category-tag category-tag--{{page.categoryId || item.id}}" *ngIf="page.categoryName || item.name">{{page.categoryName || item.name}}</span>
                                <p class="tabs__content-list-text" *ngIf="page.meta && page.meta.description">{{page.meta.description}}</p>
                            </span>
                        </li>
                    </ul>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>

    <div class="benefits-menu__view-all" *ngIf="block.data.buttonText" (click)="showAllCategories()">
        <button class="benefits-menu__view-all-button btn btn-primary" [ngClass]="{'benefits-menu__view-all-button--hidden': isButtonHidden}">{{block.data.buttonText}}</button>
    </div>
</div>
